// extracted by mini-css-extract-plugin
export default {"icons-sprite":"IconsSprite_icons-sprite__IZdto"};